import { apiSlice } from "../apiSlice";


export const NewsletterSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        newsletterlist: builder.query({
            query: (data) => ({
                url: 'newsletter',
                method: 'GET',
                credentials: "include",
            }),

        }),
    }),
});

export const {
    useNewsletterlistQuery
} = NewsletterSlice;

